module.exports = __webpack_public_path__ + "img/about2.2d19ebb8.webp";